import * as pdfjsLib from "pdfjs-dist";

import API from "../../api";

pdfjsLib.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

const readFileAsBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const pdfPagesToImages = async (file) => {
  const data = await file.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data }).promise;

  const pages = [];
  for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
    const page = await pdf.getPage(pageNumber);
    const viewport = page.getViewport({ scale: 1 });
    const scale = Math.min(3, 2000 / viewport.width);
    const scaledViewport = page.getViewport({ scale });

    const canvas = document.createElement("canvas");
    canvas.width = scaledViewport.width;
    canvas.height = scaledViewport.height;
    await page.render({ canvasContext: canvas.getContext("2d"), viewport: scaledViewport }).promise;

    pages.push(canvas.toDataURL("image/jpeg", 0.92).split(",")[1]);
  }

  pdf.destroy();
  return pages;
};

export const uploadFilesToFolder = async (files, folderId) => {
  let uploaded = 0;

  for (const file of files) {
    const isPdf = file.type === "application/pdf";
    const pages = isPdf ? await pdfPagesToImages(file) : [await readFileAsBase64(file)];

    for (const base64 of pages) {
      const response = await API.post("/annotation", { base64, fileType: isPdf ? "image/jpeg" : file.type, folderId });
      if (!response.ok) throw new Error(response.message || "Échec de l'import");
      uploaded++;
    }
  }

  return uploaded;
};
